import Vue from 'vue'
import Router from 'vue-router'
import routers from './phoneRouter'
import pcrouters from './pcRouter'

Vue.use(Router)

const RouterConfig = {
  mode: 'history',
  routes: pcrouters
};
const width = window.innerWidth;

if (/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent) || (window.WeixinJSBridge) || width < 800){
  RouterConfig.routes = routers
}

export const router = new Router(RouterConfig);



// WEBPACK FOOTER //
// ./src/router/index.js